import { getForecastDate } from "./dateUtils.js";

export const translations = {
  en: {
    title: "DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM",
    warningTitle: "Tropical Cyclone Advisory for Timor-Leste",
    advisoryNumber: "Advisory number: ",
    issuedBy: "Issued by:",
    issuedAt: "Date & Time: ",
    overview: "Overview:",
    overviewText: "The tropical depression/cyclone is situated in the southern Indian Ocean. which has been moving at a speed of 6 km/hr for the past 6 hours and is expected to intensify further as it moves to the southwest of the Timor Sea.",
    tableHeaders: ["Municipality", "Impact", "Probability"],
    observation: "Tropical Depression/ Cyclone Track Information:",
    impact: "Impact and Risk Information:",
    ocean: "Significant Wave Height Information:",
    oceanTableHeaders: ["Sl No", "Forecast Location", "Municipality", "Forecast Time (TLT)", "Value (m)", "Characteristics"],
    generalAdvisory: "General Advisory:",
    advisoryTableHeaders: ["Type", "Advisory"],
    advisoryPoints: [],
    rainfallAlertMap: "Rainfall Alert Forecast for next 3 days:",
    rainfallTableHeaders: [
      [
        {
          content: "Sl No",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "Municipality",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "Post Admin",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "Suco",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: getForecastDate(0),
          colSpan: 2,
          styles: { halign: "center" },
        },
        {
          content: getForecastDate(1),
          colSpan: 2,
          styles: { halign: "center" },
        },
        {
          content: getForecastDate(2),
          colSpan: 2,
          styles: { halign: "center" },
        },
      ],
      [
        "Rainfall (mm)",
        "Characteristics",
        "Rainfall (mm)",
        "Characteristics",
        "Rainfall (mm)",
        "Characteristics",
      ],
    ],
    noteLabel: "Note:",
    noteText:
      "The report is valid for the next 24 hours. Please monitor the website for additional information and alerts issued by the Department of Meteorology.",
    footer:
      "DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM (DRRDSS), Email: timor-leste@rimes.int, Phone: +670-74520986",
    page: "Page [i] of [pageCount]",
  },
  tetum: {
    title: "SISTEMA APOIU DEZAUN REDUSAUN RISKU DEZASTRER",
    warningTitle: "Aviso Kona-ba Siklonu Tropikal iha Timor-Leste",
    advisoryNumber: "Númeru Aviso: ",
    issuedBy: "Ema-husik husi: ",
    issuedAt: "Data no Oras: ",
    overview: "Visaun Jeral",
    overviewText: "Depresaun tropikál / siklone ne’ebé iha tasi índiku súd, movimenta ho velocidade 6 km/ora iha oras 6 liu ba, no espera atu aumenta tan bainhira movimenta ba sudoeste tasi Timor.",
    tableHeaders: ["Munisípiu", "Impaktu", "Probabilidade"],
    observation: "Informasaun Kona-ba Rota Depresasaun Tropikal / Siklone:",
    impact: "Informasaun Kona-ba Efeitu no Risku:",
    ocean: "Informasaun Kona-ba Altura Signifikante Tasi Fuan:",
    oceanTableHeaders: ["N°", "Fatin Previsaun", "Munisípiu", "Oras Previsaun (TLT)", "Valor (m)", "Karakterístika"],
    generalAdvisory: "Konsellu Jeral:",
    advisoryTableHeaders: ["Tipu", "Konsellu"],
    advisoryPoints: [],
    rainfallAlertMap: "Previsaun Alerta Udan ba loron 3 ne’ebé mai:",
    rainfallTableHeaders: [
      [
        {
          content: "N°",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "Municipio",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "Administradór Postu",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "Suco",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: getForecastDate(0),
          colSpan: 2,
          styles: { halign: "center" },
        },
        {
          content: getForecastDate(1),
          colSpan: 2,
          styles: { halign: "center" },
        },
        {
          content: getForecastDate(2),
          colSpan: 2,
          styles: { halign: "center" },
        },
      ],
      [
        "Lluvia (mm)",
        "Características",
        "Lluvia (mm)",
        "Características",
        "Lluvia (mm)",
        "Características",
      ],
    ],
    noteLabel: "Nota:",
    noteText:
      "Relatóriu ne’e válidu ba oras 24 oin. Favor monitoriza website ba informasaun adisional no alerta sira ne’ebé Departamentu Meteorolojia ema-husik.",
    footer:
      "SISTEMA APOIU DESIZAUN REDUSAUN RISKU DEZASTRE (DRRDSS), Email: timor-leste@rimes.int, Telefone: +670-74520986",
    page: "Pajina [i] husi [pageCount]",
  },
};

export const rainfallCharacteristicsTranslations = {
  en: {
    NoRisk: "NoRisk",
    Low: "Low",
    Medium: " Medium",
    High: "High",
    "N/A": "N/A",
  },
  tetum: {
    NoRisk: "La iha",
    Low: "Kraik",
    Medium: "Meiu riku",
    High: "Forte",
    "N/A": "Laiha Dadus",
  },
};

export const characteristicColors = {
  NoRisk: [148, 203, 85],
  Low: [243, 235, 18],
  Medium: [243, 155, 58],
  High: [230, 45, 58],
  "N/A": [222, 222, 223],
};